(function () {
  function readUtms() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
    };
  }

  function digitsOnlyPhone(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 10);
  }

  function formatPhoneCo(digits) {
    var d = digitsOnlyPhone(digits);
    if (d.length <= 3) return d;
    if (d.length <= 6) return d.slice(0, 3) + ' ' + d.slice(3);
    return d.slice(0, 3) + ' ' + d.slice(3, 6) + ' ' + d.slice(6);
  }

  function init(root) {
    if (!root || root.dataset.ktmLeadInit === '1') return;
    root.dataset.ktmLeadInit = '1';

    var form = root.querySelector('form');
    var statusEl = root.querySelector('[data-ktm-lead-status]');
    var proxyPath = root.dataset.proxyPath || '/apps/ktm-lead';
    var productHandle = root.dataset.productHandle || '';
    var isEbike = root.dataset.isEbike === 'true';

    if (!form) return;

    var phoneInput = form.phone;
    if (phoneInput) {
      phoneInput.value = '';
      phoneInput.addEventListener('input', function () {
        var digits = digitsOnlyPhone(phoneInput.value);
        phoneInput.value = formatPhoneCo(digits);
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstName = form.first_name && form.first_name.value
        ? form.first_name.value.trim().slice(0, 120) : '';
      var email = form.email && form.email.value
        ? form.email.value.trim().toLowerCase() : '';
      var phone = digitsOnlyPhone(form.phone && form.phone.value);
      var city = form.city && form.city.value ? form.city.value.trim() : '';

      if (!firstName) {
        if (statusEl) {
          statusEl.textContent = 'Ingresa tu nombre.';
          statusEl.hidden = false;
        }
        return;
      }

      if (email && (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))) {
        if (statusEl) {
          statusEl.textContent = 'Ingresa un correo válido o deja ese campo vacío.';
          statusEl.hidden = false;
        }
        return;
      }

      if (phone.length !== 10) {
        if (statusEl) {
          statusEl.textContent = 'Ingresa tu celular de 10 dígitos (empieza en 3).';
          statusEl.hidden = false;
        }
        return;
      }
      if (!city) {
        if (statusEl) {
          statusEl.textContent = 'Selecciona tu ciudad.';
          statusEl.hidden = false;
        }
        return;
      }

      var horizonEl = form.purchase_horizon;
      var purchaseHorizon = horizonEl && horizonEl.value ? horizonEl.value : '';
      if (!purchaseHorizon) {
        if (statusEl) {
          statusEl.textContent = 'Indica en cuánto planeas comprar.';
          statusEl.hidden = false;
        }
        return;
      }

      var financingEl = form.querySelector('input[name="seeks_financing"]:checked');
      if (!financingEl) {
        if (statusEl) {
          statusEl.textContent = 'Indica si buscas financiación (Sí o No).';
          statusEl.hidden = false;
        }
        return;
      }

      var notifyEl = form.querySelector('input[name="notify_email_whatsapp"]:checked');
      if (!notifyEl) {
        if (statusEl) {
          statusEl.textContent =
            'Indica si deseas recibir información por email o WhatsApp (Sí o No).';
          statusEl.hidden = false;
        }
        return;
      }

      var testDriveEl = form.test_drive_requested;
      var testDriveRequested =
        isEbike && testDriveEl && testDriveEl.checked ? true : false;

      var productInterestRaw =
        form.product_interest && form.product_interest.value
          ? form.product_interest.value.trim()
          : '';
      var productInterest = productInterestRaw
        ? productInterestRaw.slice(0, 120)
        : null;

      var utm = readUtms();
      var payload = {
        first_name: firstName || null,
        email: email || null,
        phone: phone,
        city: city,
        product_interest: productInterest,
        product_handle: productHandle,
        purchase_horizon: purchaseHorizon,
        seeks_financing: financingEl.value,
        notify_email_whatsapp: notifyEl.value,
        test_drive_requested: testDriveRequested,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
      };

      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
      }
      if (statusEl) {
        statusEl.hidden = true;
        statusEl.textContent = '';
      }

      fetch(proxyPath, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
        credentials: 'same-origin',
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          if (statusEl) {
            statusEl.textContent =
              root.dataset.successMessage ||
              '¡Listo! Un asesor KTM te contactará pronto por WhatsApp.';
            statusEl.hidden = false;
            statusEl.classList.remove('ktm-lead-form__status--error');
            statusEl.classList.add('ktm-lead-form__status--ok');
          }
          form.reset();
          if (phoneInput) phoneInput.value = '';
        })
        .catch(function () {
          if (statusEl) {
            statusEl.textContent =
              'No pudimos enviar tu solicitud. Intenta de nuevo o escríbenos por WhatsApp.';
            statusEl.hidden = false;
            statusEl.classList.remove('ktm-lead-form__status--ok');
            statusEl.classList.add('ktm-lead-form__status--error');
          }
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          }
        });
    });
  }

  document.querySelectorAll('[data-ktm-lead-form]').forEach(init);
})();
